<div class="loader-overlay" *ngIf="spinnerVisible">
  <div class="center">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="50"
      color="primary"
    ></mat-progress-spinner>
  </div>
</div>
<router-outlet></router-outlet>
